export const echartsChalkTheme = {
    name: 'chalk',
    seriesCnt: "3",
    backgroundColor: "#212130",
    titleColor: "#ffffff",
    subtitleColor: "#dddddd",
    textColorShow: false,
    textColor: "#333",
    markTextColor: "#293441",
    color: ["#7A7AFC", "#FFBA02", "#F7747B", "#72ccff", "#f7c5a0", "#d4a4eb", "#d2f5a6", "#76f2f2"],
    borderColor: "#ccc",
    borderWidth: 0,
    visualMapColor: [
        "#7A7AFC",
        "#FFBA02"
    ],
    legendTextColor: "#999999",
    nameFontColor: "#FFFFFF",
    kColor: "#7A7AFC",
    kColor0: "transparent",
    kBorderColor: "#7A7AFC",
    kBorderColor0: "#FFBA02",
    kBorderWidth: "2",
    lineWidth: "3",
    symbolSize: "0",
    symbol: "circle",
    symbolBorderWidth: "4",
    lineSmooth: true,
    graphLineWidth: "1",
    graphLineColor: "#ffffff",
    mapLabelColor: "#893448",
    mapLabelColorE: "rgb(137,52,72)",
    mapBorderColor: "#999999",
    mapBorderColorE: "#eb8146",
    mapBorderWidth: 0.5,
    mapBorderWidthE: 1,
    mapAreaColor: "#f3f3f3",
    mapAreaColorE: "rgba(255,178,72,1)",
    axes: [
        {
            type: "all",
            name: "Universal Axes",
            axisLineShow: true,
            axisLineColor: "#666666",
            axisTickShow: false,
            axisTickColor: "#333",
            axisLabelShow: true,
            axisLabelColor: "#aaaaaa",
            splitLineShow: false,
            splitLineColor: ["#e6e6e6"],
            splitAreaShow: false,
            splitAreaColor: ["rgba(250,250,250,0.05)", "rgba(200,200,200,0.02)"]
        },
        {
            type: "category",
            name: "Category Axis",
            axisLineShow: true,
            axisLineColor: "#333",
            axisTickShow: true,
            axisTickColor: "#333",
            axisLabelShow: true,
            axisLabelColor: "#333",
            splitLineShow: false,
            splitLineColor: ["#ccc"],
            splitAreaShow: false,
            splitAreaColor: ["rgba(250,250,250,0.3)", "rgba(200,200,200,0.3)"]
        },
        {
            type: "value",
            name: "Value Axis",
            axisLineShow: true,
            axisLineColor: "#333",
            axisTickShow: true,
            axisTickColor: "#333",
            axisLabelShow: true,
            axisLabelColor: "#333",
            splitLineShow: true,
            splitLineColor: ["#ccc"],
            splitAreaShow: false,
            splitAreaColor: ["rgba(250,250,250,0.3)", "rgba(200,200,200,0.3)"]
        },
        {
            type: "log",
            name: "Logarithmic Axis",
            axisLineShow: true,
            axisLineColor: "#333",
            axisTickShow: true,
            axisTickColor: "#333",
            axisLabelShow: true,
            axisLabelColor: "#333",
            splitLineShow: true,
            splitLineColor: [
                "#ccc"
            ],
            splitAreaShow: false,
            splitAreaColor: ["rgba(250,250,250,0.3)", "rgba(200,200,200,0.3)"]
        },
        {
            type: "time",
            name: "Time Axis",
            axisLineShow: true,
            axisLineColor: "#333",
            axisTickShow: true,
            axisTickColor: "#333",
            axisLabelShow: true,
            axisLabelColor: "#333",
            splitLineShow: true,
            splitLineColor: ["#ccc"],
            splitAreaShow: false,
            splitAreaColor: ["rgba(250,250,250,0.3)", "rgba(200,200,200,0.3)"]
        }
    ],
    axisSeperateSetting: false,
    toolboxColor: "#999999",
    toolboxEmphasisColor: "#666666",
    tooltipAxisColor: "#cccccc",
    tooltipAxisWidth: 1,
    timelineLineColor: "#FFBA02",
    timelineLineWidth: 1,
    timelineItemColor: "#FFBA02",
    timelineItemColorE: "#F7747B",
    timelineCheckColor: "#7A7AFC",
    timelineCheckBorderColor: "#7A7AFC",
    timelineItemBorderWidth: 1,
    timelineControlColor: "#FFBA02",
    timelineControlBorderColor: "#FFBA02",
    timelineControlBorderWidth: 0.5,
    timelineLabelColor: "#FFBA02",
    datazoomBackgroundColor: "rgba(255,255,255,0)",
    datazoomDataColor: "rgba(114,204,255,1)",
    datazoomFillColor: "rgba(114,204,255,0.2)",
    datazoomHandleColor: "#72ccff",
    datazoomHandleWidth: "100",
    datazoomLabelColor: "#333333"
}